import React from 'react';
import {
  Area,
  AreaChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
} from 'recharts';
import {Callout} from '@blueprintjs/core';
import {IconNames} from '@blueprintjs/icons';

interface SparklineChartProps {
  uid: string;
  data: any[];
  color: {primary: string; secondary: string};
}

const SparklineChart = ({
  uid,
  data,
  color
}: SparklineChartProps) => {
  if (!data?.length) {
    return null;
  } if (data.length === 1) {
    return (
      <Callout
        icon={IconNames.INFO_SIGN}
        title="Insufficient data"
      >
        Insufficient data to render Sparkline. More than 1 row is needed.
      </Callout>
    );
  }

  return (
    <ResponsiveContainer
      width="100%"
      height={220}
    >
      <AreaChart data={data}>
        <Tooltip />
        <XAxis
          id={"x_axis_" + uid.toLowerCase()}
          dataKey="x"
          ticks={[data[0].x, data[data.length - 1].x]}
          interval={'preserveStartEnd'}
          tickLine={false}
          axisLine={false}
        />
        <defs>
          {/* this lineGradient is used to fill the Area Chart */}
          <linearGradient id={uid.toLowerCase()} x1="0" y1="0" x2="0" y2="1">
            <stop
              offset="5%"
              stopColor={color.secondary}
              stopOpacity={0.8}
            />
            <stop
              offset="95%"
              stopColor={color.secondary}
              stopOpacity={0}
            />
          </linearGradient>
        </defs>
        <Area
          type="monotone"
          dataKey="y"
          stroke={color.primary}
          strokeWidth={2}
          fillOpacity={1}
          fill={`url(#${uid.toLowerCase()})`}
          animationDuration={300}
        />
      </AreaChart>
    </ResponsiveContainer>
  )
}

export default SparklineChart;
